export enum BimProjectSystemAttributeType {
    Priority = "Priority",
    Discipline = "Discipline",
    Zone = "Zone",
    Phase = "Phase",
    Team = "Team",
    Notify = "Notify",
}
